import {
    OFFICER_ADMIN_FAILED,
    OFFICER_ADMIN_FETCHING,
    OFFICER_ADMIN_SUCCESS,
} from "../../Constants.ts";

export interface OfficeAdminState {
    isFetching: boolean;
    isError: boolean;
    result: any;
}

const initialState: OfficeAdminState = {
    isFetching: false,
    isError: false,
    result: null,
};

export default (state = initialState, { type, payload }: any): OfficeAdminState => {
    switch (type) {
        case OFFICER_ADMIN_FETCHING:
            return { ...state, isFetching: true, isError: false, result: null };
        case OFFICER_ADMIN_SUCCESS:
            return { ...state, isFetching: false, isError: false, result: payload };
        case OFFICER_ADMIN_FAILED:
            return { ...state, isFetching: false, isError: true, result: null };
        default:
            return state;
    }
};
